// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconAeurm } from "../../../icons/mono/build/icon-aeurm.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const AeurmIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconAeurm.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  AeurmIcon.displayName = 'AeurmIcon';
}

export default AeurmIcon;